import React, { useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/Hero";
import { FeatureCards } from "@/components/FeatureCards";
import { CategorySection } from "@/components/CategorySection";
import { AdUnit } from "@/components/AdUnit";

export default function Home() {
  const [prompt, setPrompt] = useState("");
  const [mode, setMode] = useState("understand");
  const heroRef = useRef(null);
  const [params] = useSearchParams();
  const ask = params.get("ask");
  const askMode = params.get("mode") || "understand";

  const focusHero = (newMode) => {
    if (newMode) setMode(newMode);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => heroRef.current?.focus(), 350);
  };

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main className="flex-1">
        <Hero ref={heroRef} prompt={prompt} setPrompt={setPrompt} mode={mode} setMode={setMode} autoPrompt={ask} autoMode={askMode} />
        <FeatureCards onPick={(m) => focusHero(m)} />
        <AdUnit slot="2429237617" format="auto" className="my-10 sm:my-14" />
        <CategorySection />
        <AdUnit slot="9922293832" format="autorelaxed" className="my-10 sm:my-14" />
      </main>
      <Footer />
    </div>
  );
}
